export const accountTypes = [
  {
    type: 'SAVINGS_ACCOUNT',
    name: 'Cuenta de ahorros'
  },
  {
    type: 'CURRENT_ACCOUNTS',
    name: 'Cuenta corriente'
  }
];